module.exports = __webpack_public_path__ + "static/img/aw.513ef5fd.svg";